import { Card, Col, Create, Form, Input, Row, Space, useForm } from '@pankod/refine-antd';
import { useUniqueValidator } from 'hooks/useUniqueValidator';
import { IWarehouse } from 'interfaces';
import { checkWarehouseCodeUnique, checkWarehouseNameUnique } from 'services/warehouse';
import { removeEmptyObject } from 'utilities/shared';

export const WarehouseCreate: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IWarehouse>({
    metaData: {
      fields: [
        'id',
        'name',
        'email',
        'warehouseCode',
        'mobileNumber',
        {
          address: ['street', 'area', 'city', 'country', 'zip'],
        },
      ],
    },
  });

  const validateWarehouseCode = useUniqueValidator({
    checkUnique: checkWarehouseCodeUnique,
    errorMessage: 'Warehouse Code already exists',
  });
  const validateWarehouseName = useUniqueValidator({
    checkUnique: checkWarehouseNameUnique,
    errorMessage: 'Warehouse Name already exists',
  });

  return (
    <Create isLoading={queryResult?.isFetching} saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          isActive: true,
        }}
        onFinish={(values) => {
          removeEmptyObject(values, 'address');
          formProps?.onFinish?.(values); // call refine's original submit
        }}
      >
        <Row justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Form.Item
              label="Warehouse Name"
              name="name"
              validateTrigger="onChange"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Warehouse name is required',
                },
                { validator: validateWarehouseName },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Email"
              name="email"
              // rules={[
              //   {
              //     required: true,
              //     type: 'email',
              //   },
              // ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Mobile Number"
              name="mobileNumber"
              rules={[
                // {
                //   required: true,
                // },
                {
                  pattern: /^(\+\d{1,3}[- ]?)?\d{8,12}$/,
                  message: 'Provide valid number',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Unique ID"
              name="warehouseCode"
              validateTrigger="onChange"
              hasFeedback
              rules={[
                // { required: true, message: 'Warehouse code is required' },
                { validator: validateWarehouseCode },
              ]}
            >
              <Input />
            </Form.Item>
            <Card title="Address">
              <Space align="center" size="large" style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Form.Item
                  label="Street"
                  name={['address', 'street']}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Area"
                  name={['address', 'area']}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input />
                </Form.Item>
              </Space>
              <Space align="center" size="large" style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Form.Item
                  label="City"
                  name={['address', 'city']}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Country"
                  name={['address', 'country']}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input />
                </Form.Item>
              </Space>
              <Space align="center" size="large" style={{ display: 'flex' }}>
                <Form.Item
                  label="Zip"
                  name={['address', 'zip']}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input />
                </Form.Item>
              </Space>
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
